
























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  List,
  Checkbox,
  CheckboxGroup,
  Button,
  Lazyload,
  Dialog,
  Toast,
  Icon,
} from 'vant';

import { getVoteList } from '../api';

Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Lazyload)
  .use(Dialog)
  .use(Button)
  .use(Toast)
  .use(Icon);

@Component
export default class VoteList extends Vue {
  @Prop() listType!: any;
  @Prop({ default: '' }) search!: any;
  @Prop() order!: string;
  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];

  get words() {
    return this.search;
  }
  // 初使加载
  async onLoad() {
    // getVoteList(this.listType, this.page, this.order, this.words).then(
    //   (res: any) => {
    //     this.fetchListData(res);
    //   },
    // );
    if (this.finished) {
      return console.log('no more data');
    }
    this.loading = true;
    let ret: any;
    ret = await getVoteList(this.listType, this.page, this.order, this.words);
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.getListData = [...this.getListData, ...ret.data];
      this.page++;
    } else {
      this.finished = true;
    }
  }
  // fetchListData(res: any) {
  //   this.page = this.page + 1;
  //   if (!res.data || res.data.length === 0) {
  //     console.log(1111);
  //     this.finished = true;
  //   } else {
  //     if (res.data.length > 0) {
  //       console.log(22222);
  //       this.getListData = [...this.getListData, ...res.data];
  //       this.page = this.page + 1;
  //       this.finished = false;
  //     } else {
  //       console.log(33333);
  //       this.finished = true;
  //     }
  //   }
  // }

  // 进入详情页
  enterDetailPage(item: any, index: any) {
    this.$emit('enterDetailPage', item.id, index);
  }

  @Watch('search')
  onSearchChanged() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.getListData = [];
    if (!this.search) {
      return;
    }
    this.onLoad();
  }

  @Watch('listType', {
    immediate: true,
  })
  onListTypeChanged() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.getListData = [];
    this.onLoad();
  }
  @Watch('order')
  onRankConditionChange() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.getListData = [];
    this.onLoad();
  }
}
